// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserMenu-module__Trigger__wN11O:hover {
    outline: var(--ds-05x) solid var(--ds-wrapper-button-hover-color);
    outline-offset: var(--ds-05x);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Trigger": `UserMenu-module__Trigger__wN11O`
};
export default ___CSS_LOADER_EXPORT___;
